import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class MailService extends ApiService {
  entityType = EntityType.MAIL;
  url = 'api/mails/';
}
